import React, {
    useState, useEffect, useMemo, useCallback
} from 'react';
import { CONSTRUCTOR_PODS } from 'constants/constructorConstants';
import anaUtils from 'analytics/utils';
import { useGraphSimilarProductRecommendations } from 'hooks/useGraphRecommendations';

const NUM_RESULTS = 6;

export const useFilteredRecommendations = currentProduct => {
    const [podId, setPodId] = useState(null);

    const { recommendations, updateRecommendations, isFetching } = useGraphSimilarProductRecommendations();

    const constructorPayload = useMemo(() => {
        if (!podId) {
            return null;
        }

        const payload = {
            request: {
                numResults: NUM_RESULTS,
                podId,
                itemIds: [currentProduct?.productDetails?.productId]
            },
            additionalParams: {
                quantity: 3,
                sentimentTypes: ['PROS'],
                sentimentSources: ['BV']
            }
        };

        if (podId === CONSTRUCTOR_PODS.SIMILAR_PRODUCTS_UNDER_PRICE) {
            const priceAsNumber = anaUtils.removeCurrencySymbol(currentProduct?.currentSku?.listPrice);

            if (priceAsNumber) {
                payload.request = {
                    ...payload.request,
                    preFilterExpression: {
                        name: 'Price',
                        range: { min: '0', max: priceAsNumber }
                    }
                };
            }
        }

        return payload;
    }, [podId, currentProduct?.productDetails?.productId]);

    useEffect(() => {
        const similarProductVariants = currentProduct?.cxsContent?.similarProductsComparison?.featuresData;

        if (similarProductVariants?.length) {
            setPodId(similarProductVariants[0].key);
        }
    }, [currentProduct]);

    // Fetch recommendations when filter changes
    useEffect(() => {
        if (!constructorPayload) {
            return;
        }

        updateRecommendations(constructorPayload);
    }, [constructorPayload]);

    const updateFilter = useCallback(key => {
        setPodId(key);
    }, []);

    return {
        podId,
        isFetching,
        productRecommendationsData: recommendations[podId] || {},
        updateFilter
    };
};
